import { PrivateRoute } from "./components/PrivateRoute/PrivateRoute";

import { NotFound } from "./views/NotFound/NotFound";
import { Dashboard } from "./views/Dashboard/Dashboard";
import { Details } from "./views/Details/Details";
import { Login } from "./views/Login/Login";
import { Report } from "./views/Report/Report";
import { Logs } from "./views/Report/Logs";
import { Users } from "./views/Users/Users";
import { EditUser } from "./views/EditUser/EditUser";
import { CreateUser } from "./views/CreateUser/CreateUser";
import { ChangePassword } from "./views/ChangePassword/ChangePassword";
import { UserDetails } from "./views/UserDetails/UserDetails";
import { ForgotPassword } from "./views/ForgotPassword/ForgotPassword";


const routes = [
  {
    path: "/dashboard",
    element: <PrivateRoute element={<Dashboard />} />,
    login: true,
    // Add additional configuration options as needed
  },
  {
    path: "/details/:upc",
    element: <PrivateRoute element={<Details />} />,
    login: true,
    // Add additional configuration options as needed
  },
  {
    path: "/login",
    element: <Login />,
    login: true,
    // Add additional configuration options as needed
  },
  {
    path: "/report/upload",
    element: <PrivateRoute element={<Report />} />,
    login: true,
    // Add additional configuration options as needed
  },
  {
    path: "/report/logs",
    element: <PrivateRoute element={<Logs />} />,
    login: true,
    // Add additional configuration options as needed
  },
  {
    path: "/admin/users",
    element: <PrivateRoute adminOnly={true} element={<Users />} />,
    login: true,
    adminOnly: true,
    // Add additional configuration options as needed
  },
  {
    path: "/admin/users/edit/",
    element: <PrivateRoute adminOnly={true} element={<EditUser />} />,
    login: true,
    adminOnly: true,
    // Add additional configuration options as needed
  },
  {
    path: "/admin/users/new/",
    element: <PrivateRoute adminOnly={true} element={<CreateUser />} />,
    login: true,
    adminOnly: true,
    // Add additional configuration options as needed
  },
  {
    path: "/user/:id/change_password",
    element: <PrivateRoute element={<ChangePassword />} />,
    login: true,
    // Add additional configuration options as needed
  },
  {
    path: "/user/:id/details",
    element: <PrivateRoute element={<UserDetails />} />,
    login: true,
    // Add additional configuration options as needed
  },
  {  
    path: "/forgot_password",
    element: <PrivateRoute  element={<ForgotPassword />} forgotPassword={true} />,
    login: true,
    // Add additional configuration options as needed
  },
  {
    path: "*",
    element: <NotFound />,
  }
];

export default routes;
